import md5 from 'md5'

import { queueAnalyticsEvent,SeoEvent } from 'lib/gtm'
import { collectItemsByCart } from 'modules/cart'
import {
  CustomerTypes,
  getDatalayerPhoneNumber,
  isCustomerAdult
} from 'modules/customer'
import { ProductSeoStorage } from 'shared/analytics'
import { getNumberOfDayFromDate } from 'shared/utils/date'

import { SaleOrder } from './types'

export const gtmCancelSaleOrderEvent = (
  order: SaleOrder,
  customer: CustomerTypes
) => {
  const {
    deliveryAddressStreet,
    deliveryAddressCity,
    deliveryAddressPostalCode,
    deliveryAddressPhoneNumber,
    deliveryAddressHouseNumber,
    deliveryAddressFlatNumber,
    deliverySlot,
    paymentMethod,
    code,
    paymentValue,
    deliveryCostGross,
    totalValueVat,
    items: orderItems,
    discountCodes
  } = order
  const isUserAdult = isCustomerAdult(customer.dateOfBirth)

  const email = md5(customer.email).toString()
  const hour = deliverySlot?.start.substring(0, 2) || ''
  const paymentType = paymentMethod.name as string
  const phoneNumber = getDatalayerPhoneNumber(deliveryAddressPhoneNumber)

  const items = collectItemsByCart(orderItems)

  const dataLayerPayload = {
    event: SeoEvent.REFUND_ORDER, //constant
    type: 'ecommerce', //constant
    user_id: customer.code, //User ID from crm if logged in, if not we return undefined
    user_adult: isUserAdult, //1 if user have more than 18 years, 0 - if no, if no value we return undefined
    hashed_email: email, //customer email in md5 - if logged in, if not we return undefined
    delivery_week_day: getNumberOfDayFromDate(deliverySlot?.date || ''), //delivery day of the week - 1 it is monday, 2 tuesday, etc.
    delivery_hour: hour, //delivery hour in 24 hours, starting 00, 01, 02
    payment_type: paymentType, //payment type
    ltv: customer?.ltv, //life time value with current purchase
    total_transactions: customer?.totalTransactions || undefined, //total transactions client made with current
    new_customer: !!customer?.isNewClient, //Information whether the customer has bought from us before. If he has bought then the value is true, if not - false
    last_purchase_date: customer?.lastOrder || undefined, //Last time user bought, if new client than undefined
    first_purchase_date: customer?.firstOrder || undefined, //First time user bought
    user_data: {
      email: customer.email,
      phone_number: phoneNumber,
      address: {
        first_name: customer.firstName,
        last_name: customer.lastName,
        street: `${deliveryAddressStreet} ${deliveryAddressHouseNumber}${
          deliveryAddressFlatNumber ? `/${deliveryAddressFlatNumber}` : ''
        }`,
        city: deliveryAddressCity,
        region: undefined,
        postal_code: deliveryAddressPostalCode,
        country: 'PL'
      }
    }, //first party data which we can use for google ads enhanced conversions - set undefined if no value
    ecommerce: {
      transaction_id: code, //transaction id
      value: paymentValue.value / 100, //total value paid (with taxes, shipping, etc)
      tax: totalValueVat.value / 100, //taxes - default 0
      shipping: deliveryCostGross.value / 100, //shipping cost - default 0
      currency: 'PLN', //currency,

      coupon: discountCodes[0]?.code || undefined, //coupon if exists - if not undefined
      items
    }
  }

  queueAnalyticsEvent({ ecommerce: null }, true)
  queueAnalyticsEvent(dataLayerPayload, true)

  ProductSeoStorage.clear()
}
